<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="TotalCount"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <b-badge pill variant="light-primary"> {{ TotalCount }} </b-badge>
      </div>
    </li>

    <!-- Push Notifications -->
    <div class="scrollable-container media-list scroll-area" tagname="li">
      <div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">Alerts</h6>
      </div>

      <div v-if="loading" class="d-flex justify-content-center my-1">
        <b-spinner
          variant="success"
          label="Spinning"
          block
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>

      <b-link
        v-if="!loading"
        v-for="(notifications, index) in sortedNotifications"
        :key="notifications.id"
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" variant="success">
              <feather-icon icon="AlertCircleIcon" />
            </b-avatar>
          </template>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <p class="media-heading">
                <span class="font-weight-bolder">
                  {{ notifications.title }}
                </span>
              </p>
              <small class="notification-text text-danger fw-bold">
                {{ notifications.subTitle }}
              </small>
            </div>
            <div class="d-flex align-items-center">
              <!-- View Button -->
              <b-button
  v-if="notifications.url"
  variant="success"
  size="sm"
  class="ml-2"
  @click="openUrl(notifications.url)"
>
  View
</b-button>
<!-- Remove Button -->
<b-button
  variant="flat-danger"
  class="btn-icon rounded-circle ml-2"
  @click.stop="deletePushNotification(notifications.id)">
  <feather-icon icon="XIcon" />
</b-button>


            </div>
          </div>
        </b-media>
      </b-link>
    </div>

    <!-- Notifications -->
    <!-- <div class="scrollable-container media-list scroll-area" tagname="li">
      <div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">Stock Alerts</h6>
      </div>

      <div v-if="loading" class="d-flex justify-content-center my-1">
        <b-spinner
          variant="success"
          label="Spinning"
          block
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>
      <b-link
        v-if="!loading"
        v-for="(notification, index) in notification.itemList"
        :key="notification.id"
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" variant="danger">
              <feather-icon icon="AlertCircleIcon" />
            </b-avatar>
          </template>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <p class="media-heading">
                <span class="font-weight-bolder">
                  {{ notification.itemName }}
                </span>
              </p>
              <small class="notification-text text-danger fw-bold">
                Current Stock: {{ notification.currentStock }}
              </small>
            </div>
            <b-button
              variant="danger"
              size="sm"
              class="ml-auto"
              @click="deleteNotification(notification.id)"
            >
              Delete
            </b-button>
          </div>
        </b-media>
      </b-link>
    </div> -->
  </b-nav-item-dropdown>
</template>


<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
  BSpinner,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,

    ToastificationContent,
    BButton,
    BFormCheckbox,
    BSpinner,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      TotalCount: 0,
      alertCount: 0,
      pushalertCount: 0,
      alertCountSystem: [],
      pushalertCountSystem: [],
    };
  },

  computed: {

    ...mapGetters("notificationModule", {
      notification: "notification",
      loading: "loading",
    }),
    ...mapGetters("notificationModule", {
      pushnotification: "pushnotification",
      loading: "loading",
    }),
    sortedNotifications() {

      if(this.pushnotification.itemList)
    {
      return [...this.pushnotification.itemList].sort(
      (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
    );
    }
    else{
      return [];
    }
  
  }
  },

  methods: {
    ...mapActions("notificationModule", ["getNotificationsAction", "putPushNotificationAction"]),
    ...mapActions("notificationModule", ["getPushNotificationAction"]),

    async deleteNotification(index) {
      // Remove the notification from the itemList
      this.notification.itemList.splice(index, 1);

      // Optionally update the alert count
      this.alertCount = this.notification.itemList.length;
    },
    async openUrl(url) {
      //todo SD set notification as IsActiveClosed

      if (url) {
        window.open(url, "_blank");
      }
    },
    async deletePushNotification(notificationId) {
  const notificationIndex = this.pushnotification.itemList.findIndex(
    (item) => item.id === notificationId
  );
  if (notificationIndex !== -1) {
    this.pushnotification.itemList.splice(notificationIndex, 1);
    this.pushalertCount = this.pushnotification.itemList.length;
    this.TotalCount = this.alertCount + this.pushalertCount

    try {
      await this.putPushNotificationAction(notificationId);
    } catch (error) {
      this.pushnotification.itemList.splice(notificationIndex, 0, {
        id: notificationId,
      });
      this.pushalertCount = this.pushnotification.itemList.length;
      this.TotalCount = this.alertCount + this.pushalertCount
    }
  }
},

  },
  async mounted() {
    // await this.getNotificationsAction()
    //   .then(() => {
    //     this.alertCount = this.notification.totalCount;
    //     this.alertCountSystem = this.notification.itemList;
    //   })
    //   .catch((response) => {
    //     console.log(response);
    //   });

    await this.getPushNotificationAction()
      .then(() => {
        console.log(this.pushnotification);
        this.pushalertCount = this.pushnotification.itemList.length;
        this.pushalertCountSystem = this.pushnotification.itemList;
      })
      .catch((response) => {
        console.log(response);
      });
      this.TotalCount = this.alertCount + this.pushalertCount
  },
};
</script>

<style>
.scrollable-container {
  overflow: auto;
}

.b-button {
  border-radius: 50%;
  padding: 0.25rem;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
}

</style>
